<mat-dialog-content data-testid="analysis-history-dialog" class="mat-dialog-content" *ngIf="ticketHistory">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Operator Analysis History</h4>
    <i data-testid="analysis-history-close" class="fas fa-times pull-right fontL3" (click)="hideModal()"></i>
  </div>
  <div class="modal-body mt-0">
    <div class="col-xs-12 mt-3 text-center" *ngIf="!ticketHistory.length">No History found</div>
    <div class="col-xs-12 bdr-btm pb-3 bold" *ngIf="ticketHistory.length">
      <div class="col-xs-6 bold">Operator Analysis Reponse</div>
      <div class="col-xs-2 bold">Updated By</div>
      <div class="col-xs-2 bold">Updated At</div>
      <div class="col-xs-2 bold">Allocated Team</div>
    </div>
    <div class="col-xs-12 mt-3 bg-light p-2 shdw-top" *ngFor="let ticket of ticketHistory">
      <div class="col-xs-6 pr-1 overflow-wrap">
        <div *ngFor="let item of ticket.get('operatorAnalysisResponse') | keyvalue">
            <div *ngIf="item.value">
              <b>{{ formatKey(item.key) }}:</b> {{ item.value }}
            </div>
          </div>
      </div>
      <div class="col-xs-2 pr-1 overflow-wrap">{{ticket?.get('createdBy')?.get('username')}}</div>
      <div class="col-xs-2 pr-1 overflow-wrap">{{ticket?.get('createdAt') | amDateFormat: 'MMM DD, YYYY hh:mm a'}}</div>
      <div class="col-xs-2 overflow-wrap">{{ticket?.get('teams')}}</div>
    </div>
  </div>
</mat-dialog-content>